import { render, staticRenderFns } from "./detailItem.vue?vue&type=template&id=58442b38"
import script from "./detailItem.vue?vue&type=script&lang=js"
export * from "./detailItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports